import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ReactComponent as BackgroundImage } from '../../../assests/svg/index-search-page-bg.svg';
import AurButton from '../../common/aur-button/AurButton';

import { t } from 'i18next';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  getIndexByClientIdAndProjectId,
  getSearchId,
  getQuerySearchValidate,
  savedSearchedRun,
} from '../../../api/EcaServices';
import { useCustodians } from '../../../hooks/index-search/useCustodians';
import {
  setDisabledRGFLabelArray,
  setShouldAppendUpdateRGFMsg,
  setShowModal,
  setShowRGFWarningPopup,
} from '../../../redux/slices/unSaveChangesModalSlice';
import { RootState } from '../../../redux/store';
import {
  buildDtSearchQuery,
  buildEventSource,
  extractSelectedNodeId,
  generateCustodianQuery,
  getLabelFromScopeQuery,
  isEmpty,
  parseQuery,
  wrapQueryBeforeSymbol,
  extractSavedSearchId,
  getQueryForBlank,
  QueryValidationType,
  validateQueryV2,
} from '../../../utils/utils';
import AurAdhocSearchTextArea from '../../common/aur-adhoc-search/AurAdhocSearchTextArea';
import AurIconButton from '../../common/aur-button/AurIconButton';
import AurDatePicker from '../../common/aur-date-picker/aur-date-picker';
import AurIcon, { IconColors, IconNames } from '../../common/aur-icon/AurIcon';
import AurMenu from '../../common/aur-menu/AurMenu';
import ECADrawerWithTabs from '../../eca/ECADrawerWithTabs';
import ClearConfirmAlertPopup, {
  ClearConfirmPopupType,
} from './ClearConfirmAlertPopup';
import { CustodiansDropdown } from './CustodiansDropdown';
import LeaveSearchConfirmationDialog from './LeaveSeachConfirmationDialog';
import QueryBuilderWrapper from './QueryBuilderWrapper';
import RelationshipGroupPopup, {
  RelationalGroup,
  RelationshipGroupPopupRef,
} from './RelationshipGroupPopup';

import { TreeViewBaseItem } from '@mui/x-tree-view';
import { formatQuery, RuleGroupTypeIC, transformQuery } from 'react-querybuilder';
import { ReactComponent as ExpandPanel } from '../../../assests/svg/expand_panel.svg';
import {
  ECA_DRAWER_ACTIVE_TAB,
  EciHomePageTabs,
  LOAD_DOC_TYPE,
  LOAD_TYPE,
  QUERY_PREFIX,
  QUERY_TYPE,
  SCOPE_TYPE,
  SOURCE_TYPE,
  SSE_ENDPOINT_ECA,
  SSE_SERVICE_TYPE,
} from '../../../constants/constants';
import { useToast } from '../../../contexts/toastContext/ToastContext';
import {
  IGlobalSelectedItem,
  setCloseFlyout,
  setEcaDrawerFlag,
  setGlobalSavedSearchDetails,
  setGlobalSelectedItem,
  setGlobalSelectedScopeItem,
  setIsDeduplicationModal,
  setIsQuerySaved,
  setIsSearchFromECAHome,
  setPaginationDefaultLoad,
  setSavedSearchDeleteConfirm,
  setSearchLoader,
  setShowSetScopeLoader,
} from '../../../redux/slices/ecaAdhocSearchSlice';
import {
  initialQueryData,
  removeConfidenceColumn,
  setDTSyntaxQuery,
  setEditDocsName,
  setFilterList,
  setNewSearch,
  setQueryData,
  setViewDocName,
} from '../../../redux/slices/ecaDocListSlice';
import { setEcaDocumentViewerModal } from '../../../redux/slices/ecaDocumentViewerSlice';
import {
  resetQuery,
  setIndex,
  updateQuery,
} from '../../../redux/slices/querySlice';
import {
  convertBetweenInRuleGroup,
  jsonLogicOperatorMap,
} from '../../../utils/queryBuilder';
import { LoadFileData } from '../../client-details/project-data-table/types';
import AurBanner from '../../common/aur-banner/AurBanner';
import AurEcaBanner from '../../common/aur-eca-banner/AurEcaBanner';
import AurEcaSearchLoader from '../../common/aur-eca-search-loader/AurEcaSearchLoader';
import AurPopup from '../../common/aur-popup/AurPopup';
import BulkTaggingStatusBanner from '../../eca-doc-list/bulk-tagging/BulkTaggingStatusBanner';
import { ExtendedTreeItemProps } from '../../eca-doc-list/eca-save-search/EcaSaveSearch';
import EcaDocListGrid, {
  defaultFilterModel,
} from '../../eca-doc-list/EcaDocListGrid';
import SearchResultErrorBanner from './SearchResultErrorBanner';
import QueryBuilderClearConfirmationAlert from './QueryBuilderClearConfirmationAlert';
import ResizableDocList from './ResizableDocList';
import AurEcaValidationLoader from '../../common/aur-eca-search-validation-loader/AurEcaValidationLoader';
import EcaAddToSaveSearchTemplate from '../../eca/add-to-template/EcaAddToSavedSearchesTemplate';
import QueryWarningPopupAlert from './QueryWarningPopupAlert';
import { checkSavedSearchesValidation } from '../../../api/savedSearchTemplateService';
import { AxiosError } from 'axios';
import { differenceBy, flatMap, uniqBy } from 'lodash';
import RGFWarningPopupAlert from './RGFWarningPopupAlert';
import {
  countRules,
  getDisabledRelationshipFieldText,
  isDisabledRGFExistInSavedSearch,
} from './query-field/query-field-utils';
import { IndexesType } from '../../indexing/model';
import {
  PAGE_NAME,
  usePermissionsByPage,
} from '../../../hooks/permissions/usePermissionsByPage';
import {
  GA_CLICK_TYPES,
  GA_ERROR_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
  GA_SUBPAGE_TYPE,
} from '../../../constants/analyticsConstants';
import { useAnalytics } from '../../../hooks/useAnalytics';
import { EcaSseResponse } from '../../../types/types';

export interface ISearchRequestBody {
  type: string;
  jsonLogicQuery: string; //json query from query builder
  dtSyntaxQuery: string;
  noScopeDtSyntaxQuery: string;
  relationalGroupFieldList: number[];
  scope?: {
    Type: string;
    Id: string;
    Name: string;
  };
}
export interface IndexData {
  name: string;
  type: string;
  fieldTemplateId?: number;
}
export interface IRunSearchError {
  message: string;
  runSearchDisabled: boolean;
}

const parseSearchSseErrorMessage = (errorMessage?: string): string => {
  if (!errorMessage) {
    return '';
  }
  try {
    const errorMessageObject = JSON.parse(errorMessage);
    const nestedReason =
      errorMessageObject?.failed_shards?.[0]?.reason?.caused_by?.caused_by
        ?.reason;
    return nestedReason || errorMessage;
  } catch {
    return errorMessage;
  }
};

const isElasticsearchSearchError = (errorMessage?: string): boolean => {
  if (!errorMessage) {
    return false;
  }
  try {
    const errorMessageObject = JSON.parse(errorMessage);
    return Boolean(errorMessageObject?.failed_shards);
  } catch {
    return false;
  }
};

const INDEX_TYPE_STANDARD = 'STANDARD';
const SAVE_SEARCH_DT_SYNTAX = QUERY_PREFIX.savedSearch;
const CUSTODIAN_DEFAULT_PAGE_SIZE = 1000;

const IndexSearchPage: React.FC = () => {
  const gridRef = useRef(null);
  const [showValidationErrorModal, setShowValidationErrorModal] =
    useState(false);
  const [templateValidationModalContent, setTemplateValidationModalContent] =
    useState<string | React.ReactElement>();
  const { trackGAEvent } = useAnalytics();

  const [validationLoader, setValidationLoader] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [queryBuilderMode, setQueryBuilderMode] = useState<boolean>(false);
  const isQueryBuilderRef = useRef<boolean>(false);
  const queryTextFieldRef = useRef<HTMLInputElement | null>(null);
  const relationshipGroupPopupRef = useRef<RelationshipGroupPopupRef>(null);
  const abortControllers = useRef<Map<string, AbortController>>(new Map());
  const [confirmPopupType, setConfirmPopupType] =
    useState<ClearConfirmPopupType>(ClearConfirmPopupType.confirmClearSearch);
  const [queryText, setQueryText] = useState<string>('');
  const [relationalGroupArray, setRelationalGroupArray] = useState<
    RelationalGroup[]
  >([]);
  const { selectedCustodians, queryConditionType, ...resetCustodian } =
    useCustodians({ PageSize: CUSTODIAN_DEFAULT_PAGE_SIZE });
  const [indexList, setIndexList] = useState<IndexData[]>([]);
  const [stdIndexFieldTemplateId, setStdIndexFieldTemplateId] = useState<
    number | undefined
  >();
  const [
    isShowQueryBuilderConfirmationAlert,
    setIsShowQueryBuilderConfirmationAlert,
  ] = useState<boolean>(false);
  const [showECADrawer, setShowECADrawer] = useState<boolean>(true);
  const [searchTime, setSearchTime] = useState<string>('');
  const [searchSseData, setSearchSseData] = useState<EcaSseResponse>();
  const [openSaveSearch, setOpenSaveSearch] = useState<boolean>(false);
  const [runSearchError, setRunSearchError] = useState<IRunSearchError>({
    message: '',
    runSearchDisabled: false,
  });
  const [viewDocs, setViewDocs] = useState<string>('');
  const [deduplicationModal, setDeduplicationModal] = useState<boolean>(false);
  const [shadowGlobalSelectedItem, setShadowGlobalSelectedItem] =
    useState<IGlobalSelectedItem>(null);
  const [trigger, setTrigger] = useState(0);
  const [isDisabledRunBtn, setIsDisabledRunBtn] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<number>(
    ECA_DRAWER_ACTIVE_TAB.LOADS
  );
  const [selectedViewTab, setSelectedViewTab] = useState<string>('');
  const [activeLoadFile, setActiveLoadFile] = useState<LoadFileData | null>(
    null
  );
  const [selectedTag, setSelectedTag] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const [selectedNode, setSelectedNode] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const [expandedIds] = useState<string[]>(['']);
  const [source, setSource] = useState<string>('');
  const [openWithFlyout, setOpenWithFlyout] = useState<boolean>(false);
  const [
    hasSelectedFamilyGroupIdentifier,
    setHasSelectedFamilyGroupIdentifier,
  ] = useState<boolean>(false);
  const [savedSearchScopeTextArea, setSavedSearchScopeTextArea] =
    useState<string>('');
  const [saveSearchLoader, setSaveSearchLoader] = useState<boolean>(false);
  const [clearFamilyDate, setClearFamilyDate] = useState<boolean>(false);
  const [openSavedSearchTemplateDrawer, setOpenSavedSearchTemplateDrawer] =
    useState(false);
  const [selectedSearchId, setSelectedSearchId] = useState<string | undefined>(
    ''
  );
  const [selectedSearchName, setSelectedSearchName] = useState<
    string | undefined
  >('');
  const { showToast } = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { savedSearchRelationalGroupById, builder, index } = useSelector(
    (state: RootState) => state.query
  );
  const { showRGFWarningPopup, shouldAppendUpdateRGFMsg, disabledRGFLabelArray } =
    useSelector((state: RootState) => state.unsavedChangesModal);
  const { relationalGroupsList } = useSelector(
    (state: RootState) => state.ecaAdhocSearch
  );
  const searchInputRef = useRef<HTMLElement>(null);
  const queryRef = useRef<HTMLElement>(null);
  const updateHeightsRef = useRef<(() => void) | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const errorBannerRef = useRef<HTMLDivElement>(null);
  const [queryWarningPopup, setQueryWarningPopup] = useState<{
    visible: boolean;
    errorTypes?: QueryValidationType[];
  }>({ visible: false, errorTypes: [] });

  const savedSearchRGFById = useRef<Record<string, RelationalGroup[]>>({
    ...(savedSearchRelationalGroupById ?? {}),
  });

  const [selectedTreeItem, setSelectedTreeItem] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const eventSourceRef = useRef<EventSource | null>(null);
  const [isSavedSearchSuccess, setIsSavedSearchSuccess] =
    useState<boolean>(false);
  const [inputQuery, setInputQuery] = useState<string>('');

  // Callback to trigger ResizableDocList height update
  const handleHeightChange = useCallback(() => {
    if (updateHeightsRef.current) {
      updateHeightsRef.current();
    }
  }, []);

  const { clientId } = useSelector(
    (state: RootState) => state.selectedClient
  );
  const { projectId, nlpSearchEnabled } = useSelector(
    (state: RootState) => state.reports
  );

  const {viewDocName, editDocsName, queryData} = useSelector(
    (state: RootState) => state.ecaDocList
  );

  const {
    hasSearchesPerm,
    hasSearchTermReportPerm,
    hasAIInvestigatePerm,
    hasAuditReportsPerm,
  } = usePermissionsByPage(PAGE_NAME.INDEX_SEARCH);

  const {
    globalSelectedItem,
    globalSavedSearchDetails,
    ecaDrawerFlag,
    searchLoader,
    isSearchFromECAHome,
    isQuerySaved,
    selectedLoadFile,
  } = useSelector((state: RootState) => state.ecaAdhocSearch);

  const { allDocumentsData: allDocumentsItem } = useSelector(
    (state: RootState) => state.ecaAdhocSearch
  );

  const { indexData: indexDetails } = useSelector(
    (state: RootState) => state.indexes
  );

  const initRef = useRef(true);

  useEffect(() => {
    if (searchLoader) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.queryBuilder.activeSearchProgress'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
    }
  }, [searchLoader]);

  useEffect(() => {
    setRelationalGroupArray(relationalGroupsList || []);
  }, [relationalGroupsList]);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('left-focusable-element')?.focus();
    }, 100);
  }, [showECADrawer]);

  const initialRef = useRef(true);

  useEffect(() => {
    setIsSavedSearchSuccess(false);
  }, [selectedTreeItem]);

  useEffect(() => {
    savedSearchRGFById.current = { ...(savedSearchRelationalGroupById ?? {}) };
  }, [savedSearchRelationalGroupById]);

  useEffect(() => {
    if (
      location.state &&
      !isEmpty(index?.fieldTemplateId ?? '') &&
      !isEmpty(indexList) &&
      location.state.source &&
      initialRef.current
    ) {
      let text = '';
      setSource(location.state.source);

      const loadID = selectedLoadFile?.exportId ?? '';
      const loadIDQuery = isEmpty(loadID) ? '' : ` AND LoadID=(${loadID})`;

      switch (location.state.source) {
        case SOURCE_TYPE.load:
          setShowECADrawer(true);
          setActiveTab(ECA_DRAWER_ACTIVE_TAB.LOADS);
          setActiveLoadFile(location.state.selected);
          setShadowGlobalSelectedItem(location.state.selected);
          if (location.state.selected.type == LOAD_TYPE.ALL_DOCUMENT) {
            if (initRef.current) {
              handleViewDocs(LOAD_DOC_TYPE.ALL_DOC, location.state.selected);
              dispatch(setGlobalSelectedItem(location.state.selected));
            }
            initRef.current = false;
          } else {
            text = `${QUERY_PREFIX.load}=(${location.state.selected.exportId})`;
            setQueryText(text);
          }
          break;
        case SOURCE_TYPE.savedSearch:
          dispatch(setSearchLoader(true));
          setShowECADrawer(false);
          setActiveTab(ECA_DRAWER_ACTIVE_TAB.SAVE_SEARCHES);
          setSelectedNode(location.state.selected);
          dispatch(setGlobalSavedSearchDetails(location.state.selected));
          dispatch(setNewSearch(false));
          handleViewDocs(LOAD_DOC_TYPE.SAVED_DOC, location.state.selected);
          setShadowGlobalSelectedItem(location.state.selected);
          initRef.current = false;
          break;
        case SOURCE_TYPE.tag:
          setShowECADrawer(true);
          setActiveTab(ECA_DRAWER_ACTIVE_TAB.TAGS);
          setSelectedTag(location.state.selected);
          setShadowGlobalSelectedItem(location.state.selected);
          if (location.state.selected.categoryId) {
            setSelectedRelationGroupIdArray(location.state.selected.categoryId);
          }
          if (location.state.selected?.children?.length > 0) {
            text = `${location.state.selected.label}:(${location.state.selected.children.map((item: any) => item.label).join(' OR ')})`;
          } else {
            text = `${location.state.selected.parentFolder}:(${location.state.selected.label})`;
          }
          setQueryText(text);
          break;
        case SOURCE_TYPE.custodian:
          setShowECADrawer(false);
          text = `${QUERY_PREFIX.custodian}:(${location.state.selected
            .map((item: any) => item.name)
            .join(' OR ')})${loadIDQuery}`;
          setQueryText(
            getQueryForBlank(
              text,
              location.state.selected,
              QUERY_PREFIX.custodian
            )
          );
          break;
        case SOURCE_TYPE.processingException:
          setShowECADrawer(false);
          text = `${QUERY_PREFIX.processingException}=(${location.state.selected.map((item: any) => item.name).join(' OR ')})${loadIDQuery}`;
          setQueryText(
            getQueryForBlank(
              text,
              location.state.selected,
              QUERY_PREFIX.processingException
            )
          );
          break;
        case SOURCE_TYPE.docType:
          setShowECADrawer(false);
          text = `${QUERY_PREFIX.docType}=(${location.state.selected.map((item: any) => item.documentName).join(' OR ')})${loadIDQuery}`;
          setQueryText(
            getQueryForBlank(
              text,
              location.state.selected,
              QUERY_PREFIX.docType
            )
          );
          break;
        case SOURCE_TYPE.docsWithLoad:
          setShowECADrawer(true);
          setShowECADrawer(true);
          setActiveTab(ECA_DRAWER_ACTIVE_TAB.LOADS);
          setActiveLoadFile(location.state.selected);
          setOpenWithFlyout(true);
          break;
        case SOURCE_TYPE.notTagged:
          setShowECADrawer(false);
          if (location.state?.tagData?.length > 0) {
            text = `NOT (${location.state.tagData
              .filter((field: any) => field.values && field.values.length > 0)
              .map(
                (item: any) =>
                  `${item.label}:(${(item?.values ?? []).map((valueItem: any) => valueItem?.value ?? '').join(' OR ')})`
              )
              .join(' OR ')})`;
          } else {
            handleViewDocs(LOAD_DOC_TYPE.ALL_DOC, location.state.selected);
          }
          setQueryText(`(${text})`);
          break;
        case SOURCE_TYPE.notExported:
          setShowECADrawer(false);
          text = `${QUERY_PREFIX.notExported}:(*)`;
          setQueryText(`(${text})`);
          break;
        case SOURCE_TYPE.exported:
          setShowECADrawer(false);
          text = `${QUERY_PREFIX.exported}:(*)`;
          setQueryText(text);
          break;
      }
      initialRef.current = false;
    }
  }, [location.state, index, indexList, selectedLoadFile]);

  useEffect(() => {
    if (isEmpty(location.state) && !isSearchFromECAHome) {
      dispatch(setIsSearchFromECAHome(true));
    }
  }, [dispatch, location.state]);

  useEffect(() => {
    if (
      source &&
      source != SOURCE_TYPE.savedSearch &&
      queryText &&
      !isEmpty(index?.fieldTemplateId ?? '') &&
      !isEmpty(indexList)
    ) {
      if (initRef.current) {
        dispatch(setSearchLoader(true));
        generateSearchId(false);
      }
      initRef.current = false;
    }
  }, [source, indexList.length]);

  useEffect(() => {
    dispatch(setGlobalSelectedItem(null));
    dispatch(setGlobalSelectedScopeItem(null));
    dispatch(setShowSetScopeLoader(false));
    dispatch(setSavedSearchDeleteConfirm(false));

    return () => {
      dispatch(setGlobalSelectedItem(null));
      setShadowGlobalSelectedItem(null);
      dispatch(setGlobalSavedSearchDetails(null));
      setSavedSearchScopeTextArea('');
      dispatch(setGlobalSelectedScopeItem(null));
      dispatch(setViewDocName(''));
      dispatch(setEditDocsName(''));
      dispatch(setQueryData(initialQueryData));
      dispatch(resetQuery());
      dispatch(setSavedSearchDeleteConfirm(false));

      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
      abortControllers.current.forEach((controller) => {
        controller.abort();
      });
      abortControllers.current.clear();
    };
  }, []);

  useEffect(() => {
    dispatch(setEcaDocumentViewerModal(false));
  }, [dispatch]);

  const indexMenuList = useMemo(() => {
    const otherIndices = indexList
      .filter((k) => k.name !== index?.name)
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));

    return [index, ...otherIndices].map((i) => ({
      label: i?.name,
      tooltip: i?.name,
      cssClassName:
        i?.name === index?.name ? 'aur-index-menu-selected-item' : undefined,
      onClick: () => {
        trackGAEvent({
          eventName: GA_EVENT_NAMES.CLICK,
          click: {
            name: `${i.type.toLowerCase() == INDEX_TYPE_STANDARD.toLowerCase() ? t('gaTracking.queryBuilder.standardIndex') : t('gaTracking.queryBuilder.customIndex')}`,
            type: GA_CLICK_TYPES.DROPDOWN,
            region: GA_REGIONS.BODY,
            action: t('gaTracking.queryBuilder.selectedSearchIndex'),
          },
        });
        dispatch(setIndex(i));
        dispatch(resetQuery());
      },
    }));
  }, [indexList, index, dispatch]);

  useEffect(() => {
    if (
      isSearchFromECAHome &&
      allDocumentsItem &&
      !isEmpty(index?.fieldTemplateId ?? '') &&
      !isEmpty(indexList)
    ) {
      dispatch(removeConfidenceColumn());
      setActiveLoadFile(allDocumentsItem);
      handleViewDocs(LOAD_DOC_TYPE.ALL_DOC, allDocumentsItem);
      setShadowGlobalSelectedItem(allDocumentsItem);
      dispatch(setIsSearchFromECAHome(false));
      dispatch(setGlobalSelectedItem(allDocumentsItem));
      initRef.current = false;
    }
  }, [isSearchFromECAHome, allDocumentsItem, index, indexList, dispatch]);

  const getIndexList = useCallback(
    async (clientId: string, projectId: string) => {
      try {
        const response = await getIndexByClientIdAndProjectId(
          clientId,
          projectId
        );
        if (response?.status == 200) {
          if (response?.data?.data?.length) {
            const indexes: IndexData[] = (response.data.data ?? []).filter(
              (item: IndexData) =>
                item.type.toLowerCase() !== IndexesType.nlp.toLowerCase()
            );
            setIndexList(indexes);
            const standeredIndex = response.data.data.find(
              (i: IndexData) =>
                i.type.toLowerCase() == INDEX_TYPE_STANDARD.toLowerCase()
            );
            setStdIndexFieldTemplateId(standeredIndex?.fieldTemplateId);
            if (
              !isEmpty(indexDetails?.ele) &&
              location?.state?.fromManageIndex
            ) {
              dispatch(setIndex(indexDetails?.ele));
            } else {
              dispatch(
                setIndex(
                  standeredIndex ? standeredIndex : response.data.data[0]
                )
              );
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    [dispatch, indexDetails?.ele, location?.state?.fromManageIndex]
  );

  useEffect(() => {
    if (ecaDrawerFlag) {
      dispatch(setEcaDrawerFlag(false));
    }
  }, [ecaDrawerFlag]);

  useEffect(() => {
    if (!!projectId && clientId) {
      getIndexList(clientId, projectId);
    }
  }, [projectId, clientId]);

  const [selectedRelationGroupIdArray, setSelectedRelationGroupIdArray] =
    useState<number[]>([]);

  const [isConfirmDialogVisible, setIsConfirmDialogVisible] =
    useState<boolean>(false);

  const open = Boolean(anchorEl);

  const { globalSelectedScopeItem } = useSelector(
    (state: RootState) => state.ecaAdhocSearch
  );

  const handleLinkNavigate = useCallback(
    (
      e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
      route: string,
      from: string
    ) => {
      if ((!isEmpty(queryText) || builder.rules.length) && !isQuerySaved) {
        localStorage.setItem('currentLink', route);
        dispatch(setShowModal(true));

        trackGAEvent({
          eventName: GA_EVENT_NAMES.CLICK,
          click: {
            name: from,
            type: GA_CLICK_TYPES.LINK,
            region: GA_REGIONS.BODY,
            action: t('gaTracking.global.openedUnsavedChangesModal', {
              link: from,
            }),
          },
        });
        trackGAEvent({
          eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
          subPage: {
            subpage_name: t('gaTracking.global.unsavedChangesSubpageName'),
            subpage_type: GA_SUBPAGE_TYPE.MODAL,
          },
        });

        e.preventDefault();
      } else {
        localStorage.setItem('currentPath', '');
        navigate(route);
      }
    },
    [dispatch, navigate, queryText, builder, isQuerySaved]
  );

  useEffect(() => {
    if (openSaveSearch) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.queryBuilder.qbSaveSearch'),
          subpage_type: GA_SUBPAGE_TYPE.DRAWER,
        },
      });
    }
  }, [openSaveSearch]);

  const onCancelClick = () => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t(t('gaTracking.global.cancel')),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.DRAWER,
        action: t('gaTracking.queryBuilder.canceledSavedSearch'),
        details: t('gaTracking.queryBuilder.numberOfComponents', {
          length: countRules(builder),
        }),
      },
      subPage: {
        subpage_name: t('gaTracking.queryBuilder.qbSaveSearch'),
        subpage_type: GA_SUBPAGE_TYPE.DRAWER,
      },
    });
  };

  const backFromQueryBuilder = () => {
    if (builder.rules.length) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.CLICK,
        click: {
          name: t('gaTracking.queryBuilder.exitQueryBuilder'),
          type: GA_CLICK_TYPES.BUTTON,
          region: GA_REGIONS.BODY,
          action: t('gaTracking.global.openedUnsavedChangesModal', {
            link: 'query builder',
          }),
        },
      });
      dispatch(setShowModal(true));
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.global.unsavedChangesSubpageName'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
    } else {
      setQueryBuilderMode(false);
      trackGAEvent({
        eventName: GA_EVENT_NAMES.CLICK,
        click: {
          name: queryBuilderMode
            ? t('gaTracking.queryBuilder.exitQueryBuilder')
            : t('gaTracking.queryBuilder.exitSearch'),
          type: GA_CLICK_TYPES.BUTTON,
          region: GA_REGIONS.BODY,
          action: queryBuilderMode
            ? t('gaTracking.queryBuilder.exitQueryBuilderAction')
            : t('gaTracking.queryBuilder.exitSearchAction'),
        },
      });
    }
  };

  const onECAClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
      handleLinkNavigate(
        e,
        `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
        t('indexSearchPage.back')
      ),
    [handleLinkNavigate]
  );

  const onReportClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
      handleLinkNavigate(
        e,
        `/eci-home-page/?tab=${EciHomePageTabs.STR}`,
        t('indexSearchPage.searchTermReport')
      ),
    [handleLinkNavigate]
  );

  const onECAViewSearchReportClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) =>
      handleLinkNavigate(
        e,
        '/eci-home-page/search-report',
        t('indexSearchPage.viewSearchAuditReport')
      ),
    [handleLinkNavigate]
  );

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const onChangeQueryText = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQueryText(event.target.value);
    queryTextFieldRef.current?.focus();
  };

  const isRunSearchButtonDisabled = useCallback(() => {
    return (
      runSearchError.runSearchDisabled ||
      (isEmpty(queryText) && isEmpty(selectedCustodians)) ||
      (isDisabledRunBtn ? !queryText : false)
    );
  }, [runSearchError, queryText, selectedCustodians, isDisabledRunBtn]);

  const onClickMenuButton = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    },
    []
  );

  const trackQB = () => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name: t('gaTracking.queryBuilder.name'),
        subpage_type: GA_SUBPAGE_TYPE.IN_BODY,
      },
    });
  };

  const onClickBuildWithWizard = useCallback(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.queryBuilder.useQueryBuilder'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('gaTracking.queryBuilder.gotoQueryBuilder'),
      },
    });
    if (
      !isEmpty(queryText) ||
      globalSelectedScopeItem?.id ||
      selectedRelationGroupIdArray.length > 0 ||
      savedSearchScopeTextArea
    ) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.global.unsavedChangesSubpageName'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
      setConfirmPopupType(ClearConfirmPopupType.buildWithWizard);
      setIsConfirmDialogVisible(true);
    } else {
      setQueryBuilderMode(true);
      trackQB();
    }
    localStorage.setItem('currentLink', '/index-search');
  }, [
    queryText,
    globalSelectedScopeItem?.id,
    selectedRelationGroupIdArray,
    savedSearchScopeTextArea,
  ]);

  const onClickAddRelationshipGroup = useCallback(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.queryBuilder.addRelationalGroup'),
        type: GA_CLICK_TYPES.LINK,
        region: GA_REGIONS.BODY,
        action: t('gaTracking.queryBuilder.addRelationalGroupAction'),
      },
    });
    relationshipGroupPopupRef.current?.openPopup();
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name: t('gaTracking.indexSearch.relationalGroupFieldSelected'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  }, []);

  const onSelectRelationshipGroupIds = useCallback((ids: number[]) => {
    setSelectedRelationGroupIdArray(ids);
  }, []);

  const onClickClearAllButton = useCallback(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.global.clearAll'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('gaTracking.indexSearch.clearSearchAndFilterBegin'),
      },
    });

    setConfirmPopupType(ClearConfirmPopupType.confirmClearSearch);
    setIsConfirmDialogVisible(true);
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
      subPage: {
        subpage_name: t('gaTracking.indexSearch.clearSearchQueryAndFilters'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  }, []);

  const onClickOkFromClearConfirmPopup = useCallback(
    (isClearAll = false, popupType?: ClearConfirmPopupType) => {
      setIsConfirmDialogVisible(false);
      switch (popupType ?? confirmPopupType) {
        case ClearConfirmPopupType.confirmClearSearch: {
          setQueryText('');
          setSelectedRelationGroupIdArray([]);
          resetCustodian.setSelectedCustodians([]);
          setSelectedViewTab('');
          dispatch(setGlobalSavedSearchDetails(null));
          setSavedSearchScopeTextArea('');
          dispatch(setGlobalSelectedScopeItem(null));
          dispatch(setFilterList(defaultFilterModel));
          setActiveTab(0);
          setActiveLoadFile(allDocumentsItem);
          if (viewDocName != LOAD_DOC_TYPE.ALL_DOC) {
            dispatch(setGlobalSelectedItem(null));
            setShadowGlobalSelectedItem(null);
            handleViewDocs(LOAD_DOC_TYPE.ALL_DOC, allDocumentsItem);
          }
          localStorage?.setItem('currentPath', '');
          setClearFamilyDate(true);
          setRunSearchError((prevState) => {
            return {
              ...prevState,
              message: '',
            };
          });
          isClearAll &&
            trackGAEvent({
              eventName: GA_EVENT_NAMES.CLICK,
              click: {
                name: t('gaTracking.indexSearch.yesClearIt'),
                type: GA_CLICK_TYPES.BUTTON,
                region: GA_REGIONS.MODAL,
                action: t('gaTracking.indexSearch.clearConfirmed'),
              },
              subPage: {
                subpage_name: t(
                  'gaTracking.indexSearch.clearSearchQueryAndFilters'
                ),
                subpage_type: GA_SUBPAGE_TYPE.MODAL,
              },
            });
          break;
        }
        case ClearConfirmPopupType.buildWithWizard:
        case ClearConfirmPopupType.leaveSearchConfirm: {
          trackQB();
          setQueryBuilderMode(true);
          setRunSearchError((prevState) => {
            return {
              ...prevState,
              message: '',
            };
          });
          setQueryText('');
          setSelectedRelationGroupIdArray([]);
          resetCustodian.setSelectedCustodians([]);
          dispatch(setGlobalSavedSearchDetails(null));
          setSavedSearchScopeTextArea('');
          dispatch(setGlobalSelectedScopeItem(null));
          dispatch(setGlobalSelectedItem(null));
          setShadowGlobalSelectedItem(null);
          setClearFamilyDate(true);
          break;
        }
      }
    },
    [
      allDocumentsItem,
      confirmPopupType,
      dispatch,
      resetCustodian,
      trackGAEvent,
      trackQB,
      viewDocName,
    ]
  );

  const onCancelClearAllFilter = useCallback(() => {
    setIsConfirmDialogVisible(false);
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.global.cancel'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.indexSearch.canceledClear'),
      },
      subPage: {
        subpage_name: t('gaTracking.indexSearch.clearSearchQueryAndFilters'),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  }, []);

  const isAllFieldsCleared = useCallback(
    () =>
      isEmpty(queryText) &&
      isEmpty(selectedRelationGroupIdArray) &&
      isEmpty(selectedCustodians),
    [queryText, selectedCustodians, selectedRelationGroupIdArray]
  );

  useEffect(() => {
    setHasSelectedFamilyGroupIdentifier(
      selectedRelationGroupIdArray.length > 0
    );
  }, [selectedRelationGroupIdArray]);

  const getSelectedRelationshipGroupTextArray = () =>
    relationalGroupArray
      ?.filter((item: RelationalGroup) =>
        selectedRelationGroupIdArray.includes(item.id)
      )
      .map((item) => item.name);

  const handleLoaderClose = (value: string | undefined) => {
    if (value == 'cancel') {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.CLICK,
        click: {
          name: t('gaTracking.queryBuilder.cancelSearch'),
          type: GA_CLICK_TYPES.LINK,
          region: GA_REGIONS.MODAL,
          action: t('gaTracking.queryBuilder.cancelSearchAction'),
        },
        subPage: {
          subpage_name: t('gaTracking.queryBuilder.activeSearchProgress'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
      dispatch(setSearchLoader(false));
      if (eventSourceRef.current) {
        eventSourceRef.current.close();
      }
      abortControllers.current.forEach((controller) => {
        controller.abort();
      });
    }
  };

  const checkQueryValidation = async (queryText: string) => {
    const params = `?clientId=${clientId}&projectId=${projectId}`;
    const fieldId = index?.fieldTemplateId;
    const requestBody = {
      query: queryText,
    };
    dispatch(setSearchLoader(true));
    try {
      const result = await getQuerySearchValidate(params, fieldId, requestBody);
      const responseData = result?.data?.data;

      if (responseData['success']) {
        setRunSearchError({
          message: '',
          runSearchDisabled: false,
        });
        generateSearchId(true);
      } else {
        dispatch(setViewDocName(''));
        dispatch(setSearchLoader(false));
        setRunSearchError({
          message: responseData['errors'],
          runSearchDisabled: true,
        });
      }
    } catch (err) {
      dispatch(setViewDocName(''));
      dispatch(setSearchLoader(false));
      console.log(err);
    }
  };

  const OnClickRunSearch = (): void => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.SEARCH,
      click: {
        name: t('gaTracking.queryBuilder.runSearch'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action: t('gaTracking.queryBuilder.runSearchAction'),
        details: t('gaTracking.queryBuilder.numberOfComponents', {
          length: countRules(builder),
        }),
      },
    });

    let query = '';
    if (isDisabledRGFExist()) {
      return;
    }
    if (hasDisabledRGFs) {
      dispatch(setShowRGFWarningPopup(true));
      dispatch(setShouldAppendUpdateRGFMsg(true));
      dispatch(
        setDisabledRGFLabelArray(
          getDisabledRelationshipGFieldTextFromSavedSearch()
        )
      );
      return;
    }
    if (queryBuilderMode) {
      const converted = convertBetweenInRuleGroup(builder);
      const transformed = transformQuery(converted, {
        operatorMap: { ...jsonLogicOperatorMap },
      });
      const jsonLogic = formatQuery(transformed, 'jsonlogic');
      query = parseQuery(jsonLogic);
    } else {
      query = globalSelectedScopeItem?.id
        ? wrapQueryBeforeSymbol(generateDtSyntaxQuery()[0])
        : globalSavedSearchDetails?.scope
          ? wrapQueryBeforeSymbol(
            generateDtSyntaxQuery(globalSavedSearchDetails?.scope?.scopeId)[0]
          )
          : wrapQueryBeforeSymbol(generateDtSyntaxQuery()[0]);
    }
    setInputQuery(query);
    const queryErrors = validateQueryV2(query);
    if (!queryErrors.isValid) {
      setQueryWarningPopup({
        visible: true,
        errorTypes: queryErrors.errors,
      });
    } else {
      checkQueryValidation(query);
    }
  };

  const handleSavedSearchIndex = () => {
    const savedSearchIndex = indexList.filter(
      (i) => i.fieldTemplateId === globalSavedSearchDetails?.fieldTemplateId
    )?.[0];
    savedSearchIndex && dispatch(setIndex(savedSearchIndex));
  };
  const handleSavedSearchRun = async (ecaSearchId: string) => {
    const title = index?.fieldTemplateId;
    const params = `?clientId=${clientId}&projectId=${projectId}`;
    try {
      if (clientId && projectId && ecaSearchId) {
        const url =
          `/indexes/${title}/savedSearches/${ecaSearchId}/run` + params;
        if (abortControllers.current.has(url)) {
          abortControllers.current.get(url)?.abort();
        }
        const controller = new AbortController();
        abortControllers.current.set(url, controller);
        const result = await savedSearchedRun(
          params,
          title,
          ecaSearchId,
          controller.signal
        );
        setRunSearchError({
          message: '',
          runSearchDisabled: false,
        });
        getSearchIdSse(true, result.data?.data?.requestId);
        abortControllers.current.delete(url);
      }
    } catch (error: any) {
      dispatch(setSearchLoader(false));
      setViewDocs('');
      dispatch(setGlobalSavedSearchDetails(null));
      setSavedSearchScopeTextArea('');
      dispatch(setViewDocName(''));
      const data = (error as any).response?.name as any;
      if (error.name === 'CanceledError') {
        return;
      }
      abortControllers.current.delete(
        `/indexes/${title}/savedSearches/${ecaSearchId}/run` + params
      );
      if (data?.meta?.message) {
        setRunSearchError({
          message: data.meta.message,
          runSearchDisabled: true,
        });
      } else {
        setRunSearchError({
          message: t('common.somethingWrong'),
          runSearchDisabled: true,
        });
      }
    }
  };

  const generateSyntax = (query: any) => {
    setQueryText(
      queryText.includes('(')
        ? `${queryText} AND  (${query})`
        : `(${queryText}) AND  (${query})`
    );
  };

  const getDisabledRGFfromSavedSearch = () => {
    const relationalGroupIds = new Set(
      relationalGroupsList?.map((rg) => rg.id)
    );
    const disabledRGFs = globalSavedSearchDetails?.relationalGroupList?.filter(
      (group) => !relationalGroupIds.has(group.id)
    );
    const updatedRGFs = disabledRGFs?.map((rgf) => ({ ...rgf, disabled: true }));
    return updatedRGFs || [];
  };

  const addDisabledRGFInRelationalGroupList = () => {
    const disabledRGFs = getDisabledRGFfromSavedSearch();
    const mergedRGFs = [
      ...(relationalGroupsList || []),
      ...(disabledRGFs || []),
    ].map((group: RelationalGroup, index: number) => {
      return {
        ...group,
        index: index + 1,
      };
    });
    setRelationalGroupArray(mergedRGFs);
  };

  const getDisabledRelationshipGFieldTextFromSavedSearch = useCallback(() => {
    const disabledRGFText = relationalGroupArray
      ?.filter((group) => group.disabled)
      .map((g) => g.name);
    return disabledRGFText || [];
  }, [relationalGroupArray]);

  const hasDisabledRGFs = useMemo(() => {
    const idSet = new Set(selectedRelationGroupIdArray);
    return relationalGroupArray?.some(
      (item) => item.disabled === true && idSet.has(item.id)
    );
  }, [relationalGroupArray, selectedRelationGroupIdArray]);

  const getDisabledRelationshipGFieldText = useCallback(() => {
    const savedSearchRelationalGroupArray = uniqBy(
      flatMap(Object.values(savedSearchRGFById.current ?? {})),
      'id'
    );

    const disabledRelationshipGArray = differenceBy(
      savedSearchRelationalGroupArray,
      relationalGroupsList || [],
      'id'
    );

    return disabledRelationshipGArray.map((item) => item?.name ?? '');
  }, [relationalGroupsList]);

  const isDisabledRGFExist = useCallback(() => {
    const isExist = !isEmpty(getDisabledRelationshipGFieldText());
    if (isExist) {
      dispatch(setDisabledRGFLabelArray(getDisabledRelationshipGFieldText()));
      dispatch(setShouldAppendUpdateRGFMsg(true));
      dispatch(setShowRGFWarningPopup(true));
    }
    return isExist;
  }, [dispatch, getDisabledRelationshipGFieldText]);

  const generateDtSyntaxQuery = useCallback(
    (scopeId = ''): string[] => {
      if (viewDocs === LOAD_DOC_TYPE.LOAD_DOC) {
        const query = `${QUERY_PREFIX.load}=(${shadowGlobalSelectedItem?.exportId})`;
        return [query, query];
      } else if (viewDocs === LOAD_DOC_TYPE.ALL_DOC) {
        return ['', ''];
      } else if (viewDocs === LOAD_DOC_TYPE.TAG_DOC) {
        const query = `${shadowGlobalSelectedItem?.parentFolder}:(${shadowGlobalSelectedItem?.label})`;
        return [query, query];
      }
      let finalQuery = queryText.trim();
      if (!scopeId) {
        if (viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE) {
          finalQuery =
            finalQuery +
            ` AND ${QUERY_PREFIX.load}=(${shadowGlobalSelectedItem?.exportId})`;
        } else if (viewDocs === LOAD_DOC_TYPE.TAGS_SCOPE) {
          finalQuery =
            finalQuery +
            ` AND ${shadowGlobalSelectedItem?.parentFolder}:(${shadowGlobalSelectedItem?.label})`;
        } else if (viewDocs === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE) {
          finalQuery =
            finalQuery +
            ` AND ${SAVE_SEARCH_DT_SYNTAX}:(${shadowGlobalSelectedItem?.ecaSearchId})`;
        }
      } else {
        const scopeDetails = globalSavedSearchDetails?.scope;
        if (scopeDetails?.scopeType === SCOPE_TYPE.LOAD) {
          finalQuery =
            finalQuery + ` AND ${QUERY_PREFIX.load}=(${scopeDetails?.scopeId})`;
        } else if (scopeDetails?.scopeType === SCOPE_TYPE.TAGS) {
          finalQuery = finalQuery + ` AND ${scopeDetails?.scopeName}`;
        } else if (scopeDetails?.scopeType === SCOPE_TYPE.SAVED_SEARCH) {
          finalQuery =
            finalQuery +
            ` AND ${SAVE_SEARCH_DT_SYNTAX}:(${scopeDetails?.scopeId})`;
        }
      }
      return [finalQuery.trim(), queryText.trim()];
    },
    [
      queryText,
      shadowGlobalSelectedItem?.ecaSearchId,
      shadowGlobalSelectedItem?.exportId,
      shadowGlobalSelectedItem?.label,
      shadowGlobalSelectedItem?.parentTagName,
      viewDocs,
    ]
  );

  //const prevFamilyDateRef = useRef<string>('');
  const prevCustodiansRef = useRef<any[]>([]);

  const rawQuery = useRef('');

  const checkForSavedSearch = (id: string) => {
    if (
      relationalGroupsList &&
      globalSavedSearchDetails?.relationalGroupList &&
      isDisabledRGFExistInSavedSearch(
        relationalGroupsList,
        globalSavedSearchDetails.relationalGroupList
      )
    ) {
      dispatch(setSearchLoader(false));
      dispatch(setShowRGFWarningPopup(true));
      dispatch(setShouldAppendUpdateRGFMsg(false));
      dispatch(
        setDisabledRGFLabelArray(
          getDisabledRelationshipFieldText(
            relationalGroupsList,
            globalSavedSearchDetails.relationalGroupList
          )
        )
      );
      populateGlobalSearchDetails();
    } else {
      handleSavedSearchRun(id);
    }
  };

  useEffect(() => {
    if (globalSavedSearchDetails) {
      getDisabledRGFfromSavedSearch()?.length > 0 &&
        addDisabledRGFInRelationalGroupList();
      if (viewDocName === LOAD_DOC_TYPE.SAVED_DOC)
        checkForSavedSearch(globalSavedSearchDetails?.ecaSearchId);
      else if (editDocsName === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT) {
        onSelectRelationshipGroupIds(
          globalSavedSearchDetails?.relationalGroups || []
        );
        handleSavedSearchIndex();
        setSavedSearchScopeTextArea(
          getLabelFromScopeQuery(globalSavedSearchDetails?.scope?.scopeName)
        );
        handleGlobalSelectedItem(viewDocName);
        setSearchTime('');
        if (
          globalSavedSearchDetails.queryBuilderFlag &&
          globalSavedSearchDetails.jsonLogicQuery
        ) {
          setQueryBuilderMode(true);
          dispatch(
            updateQuery(
              JSON.parse(
                globalSavedSearchDetails.jsonLogicQuery
              ) as unknown as RuleGroupTypeIC
            )
          );
        } else {
          setQueryBuilderMode(false);
          setQueryText(globalSavedSearchDetails?.query);
        }
      }
    }
  }, [globalSavedSearchDetails, viewDocName, editDocsName]);

  useEffect(() => {
    const savedSearchedScope = globalSavedSearchDetails?.scope;
    const converted = convertBetweenInRuleGroup(builder);
    const jsonLogic = formatQuery(
      transformQuery(converted, { operatorMap: { ...jsonLogicOperatorMap } }),
      'jsonlogic'
    );
    const requestBody: ISearchRequestBody = {
      type: QUERY_TYPE.DT_SEARCH,
      jsonLogicQuery: '', //json query from query builder
      dtSyntaxQuery: queryBuilderMode
        ? parseQuery(jsonLogic)
        : generateDtSyntaxQuery(
          globalSelectedScopeItem?.id ? '' : savedSearchedScope?.scopeId
        )[0],
      noScopeDtSyntaxQuery: queryBuilderMode
        ? parseQuery(jsonLogic)
        : generateDtSyntaxQuery()[1],
      relationalGroupFieldList: selectedRelationGroupIdArray,
      scope: globalSelectedScopeItem?.id
        ? defineScope()
        : {
          Type: savedSearchedScope?.scopeType ?? SCOPE_TYPE.ALL,
          Id: savedSearchedScope?.scopeId ?? '',
          Name: savedSearchedScope?.scopeName ?? '',
        },
    };

    dispatch(
      setQueryData({
        ...requestBody,
        queryBuilderMode: queryBuilderMode,
      })
    );
    dispatch(setIsQuerySaved(false));
  }, [
    selectedRelationGroupIdArray,
    queryBuilderMode,
    globalSelectedScopeItem?.id,
    builder,
  ]);

  useEffect(() => {
    if (globalSelectedScopeItem?.id) setSavedSearchScopeTextArea('');
  }, [globalSelectedScopeItem?.id]);

  const resetSearchSse = () => {
    setSearchSseData({
      SearchId: '',
      DocHits: '',
      FamilyHits: '',
      DocSetId: '',
    });
  };

  const handleViewDocs = (
    viewDocsFlag: string,
    selectedItem: IGlobalSelectedItem
  ) => {
    setSelectedRelationGroupIdArray([]);
    if (viewDocsFlag !== LOAD_DOC_TYPE.LOAD_DOC) {
      dispatch(setViewDocName(viewDocsFlag));
    }
    if (viewDocsFlag === LOAD_DOC_TYPE.ALL_DOC) {
      setQueryBuilderMode(false);
      dispatch(resetQuery());
      dispatch(setSearchLoader(true));
      dispatch(setPaginationDefaultLoad(true));
      setViewDocs(viewDocsFlag);
      setSearchTime('');
      resetSearchSse();
      dispatch(setQueryData(initialQueryData));
    } else if (viewDocsFlag === LOAD_DOC_TYPE.LOAD_DOC) {
      isQueryBuilderRef.current = queryBuilderMode;
      setQueryBuilderMode(false);
      setDeduplicationModal(true);
      setViewDocs(viewDocsFlag);
    } else if (viewDocsFlag === LOAD_DOC_TYPE.TAG_DOC) {
      setQueryBuilderMode(false);
      dispatch(resetQuery());
      dispatch(setSearchLoader(true));
      setViewDocs(viewDocsFlag);
      setSearchTime('');
      resetSearchSse();
    } else if (viewDocsFlag === LOAD_DOC_TYPE.SAVED_DOC && selectedItem?.id) {
      dispatch(setSearchLoader(true));
      setViewDocs(viewDocsFlag);
      setSearchTime('');
      resetSearchSse();
      if (
        editDocsName === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT &&
        globalSelectedItem
      ) {
        dispatch(setGlobalSelectedItem(null));
        setShadowGlobalSelectedItem(null);
      }
    } else if (
      viewDocsFlag === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT &&
      selectedItem?.id
    ) {
      setViewDocs(viewDocsFlag);
      dispatch(setEditDocsName(viewDocsFlag));
    }

    if (
      !(
        viewDocsFlag === LOAD_DOC_TYPE.SAVED_DOC ||
        viewDocsFlag === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT ||
        viewDocsFlag === LOAD_DOC_TYPE.LOAD_DOC
      )
    ) {
      dispatch(setGlobalSavedSearchDetails(null));
      setSavedSearchScopeTextArea('');
      dispatch(setGlobalSelectedItem(null));
    }
    setShadowGlobalSelectedItem(selectedItem);
    setTrigger((prev) => prev + 1);
  };

  const showTemplateValidationModal = (validationErrors: string[]) => {
    const proprietaryContentError: { error: string; body: string } = {
      error: t('savedSearchesTemplate.proprietaryContentError'),
      body: t('savedSearchesTemplate.proprietaryContentErrorBody'),
    };
    const errors: { [key: string]: { error: string; body: string } } = {
      SSVALERROR_001: {
        error: t('savedSearchesTemplate.projectSpecificIndexError'),
        body: t('savedSearchesTemplate.projectSpecificIndexErrorBody'),
      },
      SSVALERROR_002: {
        error: t('savedSearchesTemplate.projectSpecificRelationGroupError'),
        body: t('savedSearchesTemplate.projectSpecificRelationGroupErrorBody'),
      },
      SSVALERROR_003: {
        error: t('savedSearchesTemplate.projectSpecificInvalidScopeError'),
        body: t('savedSearchesTemplate.projectSpecificInvalidScopeErrorBody'),
      },
      SSVALERROR_004: {
        error: t(
          'savedSearchesTemplate.projectSpecificInvalidColumnOrderError'
        ),
        body: t(
          'savedSearchesTemplate.projectSpecificInvalidColumnOrderErrorBody'
        ),
      },
      SSVALERROR_005: {
        error: t('savedSearchesTemplate.projectSpecificInvalidQueryError'),
        body: t('savedSearchesTemplate.projectSpecificInvalidQueryErrorBody'),
      },
    };
    if (validationErrors.length == 1) {
      const errorInfo = errors[validationErrors[0]];
      setTemplateValidationModalContent(
        getTemplateValidationModalContent(errorInfo.error, errorInfo.body)
      );
      setShowValidationErrorModal(true);
      return;
    }
    if (validationErrors.length > 1) {
      setTemplateValidationModalContent(
        getTemplateValidationModalContent(
          proprietaryContentError.error,
          <>
            {proprietaryContentError.body}
            <ul className="template-error-list">
              {validationErrors.map((item, index) => {
                return <li key={index}>{errors[item].error}</li>;
              })}
            </ul>
          </>
        )
      );
      setShowValidationErrorModal(true);
      return;
    }
  };

  const handleAddToTemplate = async (selectedItem: IGlobalSelectedItem) => {
    try {
      setValidationLoader(true);
      const result = await checkSavedSearchesValidation(
        clientId,
        projectId ?? '',
        extractSavedSearchId(selectedItem?.id ?? '')
      );
      setValidationLoader(false);
      if (result.data.data.isValid) {
        setValidationLoader(false);

        setSelectedSearchId(selectedItem?.id);
        setSelectedSearchName(selectedItem?.label);
        setOpenSavedSearchTemplateDrawer(true);
        return;
      } else {
        showTemplateValidationModal(
          result.data.data.validationErrorCodes ?? []
        );
      }
    } catch (error: unknown) {
      const e = error as AxiosError;
      setValidationLoader(false);
      showToast(e.message, 'error', undefined, 'center');
    }
  };

  const handleUseAsScope = (
    viewDocsFlag: string,
    selectedItem: IGlobalSelectedItem
  ) => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.indexSearch.useAsScope'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.BODY,
        action:
          viewDocsFlag === LOAD_DOC_TYPE.LOAD_SCOPE
            ? t('gaTracking.indexSearch.changeScopeBegin')
            : t('gaTracking.indexSearch.confirmUseAsScope'),
      },
    });

    if (viewDocsFlag === LOAD_DOC_TYPE.LOAD_SCOPE) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.indexSearch.continueToUseAsScope'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
      setDeduplicationModal(true);
      setViewDocs(viewDocsFlag);
    } else if (
      viewDocsFlag === LOAD_DOC_TYPE.TAGS_SCOPE ||
      viewDocsFlag === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE
    ) {
      setViewDocs(viewDocsFlag);
      dispatch(setGlobalSelectedScopeItem(selectedItem));
      if (viewDocsFlag === LOAD_DOC_TYPE.TAGS_SCOPE) {
        setActiveTab(ECA_DRAWER_ACTIVE_TAB.TAGS);
        setSelectedViewTab(String(ECA_DRAWER_ACTIVE_TAB.TAGS));
      } else {
        setActiveTab(ECA_DRAWER_ACTIVE_TAB.SAVE_SEARCHES);
        setSelectedViewTab(String(ECA_DRAWER_ACTIVE_TAB.SAVE_SEARCHES));
      }
    }
    setSearchTime('');
    resetSearchSse();
    setShadowGlobalSelectedItem(selectedItem);
  };

  useEffect(() => {
    if (viewDocs === LOAD_DOC_TYPE.TAG_DOC) {
      generateSearchId();
    }
  }, [shadowGlobalSelectedItem, trigger]);

  useEffect(() => {
    dispatch(setIsDeduplicationModal(deduplicationModal));
  }, [deduplicationModal]);

  const defineScope = () => {
    if (
      viewDocs === LOAD_DOC_TYPE.TAG_DOC &&
      shadowGlobalSelectedItem?.id &&
      shadowGlobalSelectedItem?.label
    ) {
      return {
        Type: SCOPE_TYPE.TAGS,
        Id: extractSelectedNodeId(shadowGlobalSelectedItem.id),
        Name: shadowGlobalSelectedItem.label,
      };
    } else if (
      viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE &&
      shadowGlobalSelectedItem?.exportId &&
      shadowGlobalSelectedItem?.name
    ) {
      return {
        Type: SCOPE_TYPE.LOAD,
        Id: String(shadowGlobalSelectedItem.exportId),
        Name: shadowGlobalSelectedItem.name,
      };
    } else if (
      viewDocs === LOAD_DOC_TYPE.TAGS_SCOPE &&
      shadowGlobalSelectedItem?.id &&
      shadowGlobalSelectedItem?.label
    ) {
      return {
        Type: SCOPE_TYPE.TAGS,
        Id: extractSelectedNodeId(shadowGlobalSelectedItem.id),
        Name: `${shadowGlobalSelectedItem?.parentFolder}:(${shadowGlobalSelectedItem?.label})`, //Its only changes to get scope details for noscope dtsyntax,
      };
    } else if (
      viewDocs === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE &&
      shadowGlobalSelectedItem?.ecaSearchId &&
      shadowGlobalSelectedItem?.label
    ) {
      return {
        Type: SCOPE_TYPE.SAVED_SEARCH,
        Id: shadowGlobalSelectedItem.ecaSearchId,
        Name: shadowGlobalSelectedItem.label,
      };
    } else if (
      editDocsName === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT &&
      globalSavedSearchDetails?.scope
    ) {
      const {
        scopeName = '',
        scopeId = '',
        scopeType = SCOPE_TYPE.ALL,
      } = globalSavedSearchDetails.scope;
      return {
        Type: scopeType,
        Id: scopeId,
        Name: scopeName,
      };
    } else if (globalSavedSearchDetails?.scope) {
      const {
        scopeName = '',
        scopeId = '',
        scopeType = SCOPE_TYPE.ALL,
      } = globalSavedSearchDetails.scope;
      return {
        Type: scopeType,
        Id: scopeId,
        Name: scopeName,
      };
    }
    return {
      Type: SCOPE_TYPE.ALL,
      Id: '',
      Name: '',
    };
  };

  const populateGlobalSearchDetails = useCallback(() => {
    if (
      globalSavedSearchDetails?.queryBuilderFlag &&
      globalSavedSearchDetails?.jsonLogicQuery
    ) {
      setQueryBuilderMode(true);
      dispatch(
        updateQuery(
          JSON.parse(
            globalSavedSearchDetails.jsonLogicQuery
          ) as unknown as RuleGroupTypeIC
        )
      );
    } else if (globalSavedSearchDetails?.query) {
      setQueryText(globalSavedSearchDetails.query);
      setQueryBuilderMode(false);
    }

    onSelectRelationshipGroupIds(
      globalSavedSearchDetails?.relationalGroups || []
    );
    handleSavedSearchIndex();
    setSavedSearchScopeTextArea(
      globalSavedSearchDetails?.scope?.scopeName
        ? getLabelFromScopeQuery(globalSavedSearchDetails?.scope?.scopeName)
        : ''
    );
  }, [globalSavedSearchDetails]);

  const getSearchIdSse = (
    from: boolean,
    requestId: string,
    requestBody?: ISearchRequestBody,
    show?: boolean
  ) => {
    if (requestId && requestId != '') {
      const SSE_URL = `${SSE_ENDPOINT_ECA}/sse/${requestId}/${SSE_SERVICE_TYPE.SEARCH_SERVICE}`;
      eventSourceRef.current = buildEventSource(SSE_URL);
      eventSourceRef.current.onmessage = (event) => {
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
        }
        const responseData = JSON.parse(event.data);
        if (responseData.status.toLowerCase() == 'completed') {
          setSearchSseData(responseData.data);
          dispatch(setPaginationDefaultLoad(true));
          if (from) {
            if (globalSavedSearchDetails) {
              populateGlobalSearchDetails();
            }
          } else {
            prevCustodiansRef.current = selectedCustodians;
            setIsDisabledRunBtn(true);
            if (requestBody) {
              dispatch(
                setQueryData({
                  ...requestBody,
                  queryBuilderMode: queryBuilderMode,
                })
              );
            }
            setQueryText(generateDtSyntaxQuery()[1]);
            if (viewDocs !== LOAD_DOC_TYPE.SAVED_DOC) {
              // Removed setNewSearch true dispatch to preserve doc-list column-order
              // dispatch(setNewSearch(true));
            }
            if (show) {
              if (
                !(
                  viewDocName === LOAD_DOC_TYPE.SAVED_DOC ||
                  viewDocName === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT ||
                  viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE ||
                  viewDocs === LOAD_DOC_TYPE.TAGS_SCOPE ||
                  viewDocs === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE
                )
              ) {
                setSelectedViewTab('');
                dispatch(setGlobalSelectedItem(null));
                setShadowGlobalSelectedItem(null);
              }
              if (
                viewDocName !== LOAD_DOC_TYPE.SAVED_DOC &&
                viewDocName !== LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT
              ) {
                dispatch(setViewDocName(''));
              }
              const current = new Date().toLocaleTimeString([], {
                timeStyle: 'short',
              });
              setSearchTime(current);
            } else {
              setSearchTime('');
            }
          }
          if (viewDocName === LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT) {
            dispatch(setEditDocsName(LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT_RUN));
          } else {
            dispatch(setEditDocsName(''));
          }
        } else {
          dispatch(setSearchLoader(false));
          const rawErrorMessage = responseData.data?.['Error Message'];
          const parsedErrorMessage = parseSearchSseErrorMessage(rawErrorMessage);
          if (isElasticsearchSearchError(rawErrorMessage)) {
            setRunSearchError({
              message: parsedErrorMessage,
              runSearchDisabled: true,
            });
            showToast(t('ecaDocList.failedText'), 'error', undefined, 'center');
          } else {
            setRunSearchError({
              message: '',
              runSearchDisabled: false,
            });
            showToast(
              parsedErrorMessage || t('ecaDocList.failedText'),
              'error',
              undefined,
              'center'
            );
          }
          (gridRef.current as any)?.resetData();
        }
        if (eventSourceRef.current) {
          eventSourceRef.current.close();
        }
      };

      eventSourceRef.current.onerror = () => {
        dispatch(setSearchLoader(false));
        showToast(t('ecaDocList.failedText'), 'error', undefined, 'center');
        if (eventSourceRef.current) {
          eventSourceRef.current.close(); // Close previous connection if it exists
        }
      };
    }
  };

  const generateSearchId = async (show = false) => {
    if (hasDisabledRGFs) {
      dispatch(setSearchLoader(false));
      dispatch(
        setDisabledRGFLabelArray(
          getDisabledRelationshipGFieldTextFromSavedSearch()
        )
      );
      dispatch(setShowRGFWarningPopup(true));
      dispatch(setShouldAppendUpdateRGFMsg(true));
      return;
    }
    const title = index?.fieldTemplateId;
    const fieldTemplateIdParam = !isEmpty(title)
      ? `&fieldTemplateId=${title}`
      : '';
    const params = `?clientId=${clientId}&projectId=${projectId}${fieldTemplateIdParam}`;
    const converted = convertBetweenInRuleGroup(builder);
    const jsonLogic = formatQuery(
      transformQuery(converted, { operatorMap: { ...jsonLogicOperatorMap } }),
      'jsonlogic'
    );
    const requestBody: ISearchRequestBody = {
      type: QUERY_TYPE.DT_SEARCH,
      jsonLogicQuery: '', //json query from query builder
      dtSyntaxQuery: queryBuilderMode
        ? parseQuery(jsonLogic)
        : globalSelectedScopeItem?.id
          ? wrapQueryBeforeSymbol(generateDtSyntaxQuery()[0])
          : globalSavedSearchDetails?.scope
            ? wrapQueryBeforeSymbol(
              generateDtSyntaxQuery(
                globalSavedSearchDetails?.scope?.scopeId
              )[0]
            )
            : wrapQueryBeforeSymbol(generateDtSyntaxQuery()[0]),
      noScopeDtSyntaxQuery: queryBuilderMode
        ? parseQuery(jsonLogic)
        : wrapQueryBeforeSymbol(generateDtSyntaxQuery()[1]),
      relationalGroupFieldList: selectedRelationGroupIdArray,
      scope: defineScope(),
    };
    const url = `/indexes/${title}/searches/run` + params;
    if (abortControllers.current.has(url)) {
      abortControllers.current.get(url)?.abort();
    }
    const controller = new AbortController();
    abortControllers.current.set(url, controller);
    resetSearchSse();
    try {
      const result = await getSearchId(
        params,
        title,
        requestBody,
        controller.signal
      );
      setRunSearchError({
        message: '',
        runSearchDisabled: false,
      });
      getSearchIdSse(false, result.data.requestId, requestBody, show);
      abortControllers.current.delete(url);
    } catch (error: any) {
      dispatch(setSearchLoader(false));
      setViewDocs('');
      if (viewDocName !== LOAD_DOC_TYPE.SAVED_DOC) {
        dispatch(setViewDocName(''));
      }
      const data = (error as any).response?.data as any;
      if (error.name === 'CanceledError') {
        return;
      }
      abortControllers.current.delete(url);
      if (data?.meta?.message) {
        setRunSearchError({
          message: data.meta.message,
          runSearchDisabled: true,
        });
      } else {
        setRunSearchError({
          message: t('common.somethingWrong'),
          runSearchDisabled: true,
        });
      }
      queryData.queryBuilderMode &&
        trackGAEvent({
          eventName: GA_EVENT_NAMES.ERROR,
          error: {
            code: error.code,
            type: GA_ERROR_TYPES.VALIDATION_ERROR,
            text: data?.meta?.message || t('common.somethingWrong'),
          },
        });
    }
  };

  useEffect(() => {
    setIsDisabledRunBtn(false);
  }, [selectedCustodians, selectedRelationGroupIdArray, queryText]);

  useEffect(() => {
    if (globalSelectedItem?.isScopeSelected && queryText.length > 0) {
      setIsDisabledRunBtn(false);
    } else {
      globalSelectedItem && !queryText && setIsDisabledRunBtn(true);
    }
  }, [globalSelectedItem]);

  useEffect(() => {
    runSearchError.runSearchDisabled &&
      setRunSearchError({ ...runSearchError, runSearchDisabled: false });
  }, [queryText]);

  const handleGlobalSelectedItem = async (currentViewDocs: string) => {
    viewDocs === LOAD_DOC_TYPE.ALL_DOC &&
      setQueryText(generateDtSyntaxQuery()[1]);
    if (
      (viewDocName == LOAD_DOC_TYPE.SAVED_DOC ||
        viewDocName == LOAD_DOC_TYPE.SAVED_SEARCHES_EDIT) &&
      (viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE ||
        viewDocs === LOAD_DOC_TYPE.TAGS_SCOPE ||
        viewDocs === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE)
    ) {
      return;
    }
    if (
      viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE ||
      viewDocs === LOAD_DOC_TYPE.TAGS_SCOPE ||
      viewDocs === LOAD_DOC_TYPE.SAVE_SEARCHES_SCOPE
    ) {
      dispatch(setSearchLoader(false));
      dispatch(setGlobalSelectedItem(null));
      setSelectedViewTab('');
    } else {
      dispatch(setSearchLoader(false));
      setTimeout(() => {
        if (currentViewDocs === LOAD_DOC_TYPE.ALL_DOC) {
          dispatch(setGlobalSelectedItem(allDocumentsItem));
        } else if (shadowGlobalSelectedItem) {
          dispatch(setGlobalSelectedItem(shadowGlobalSelectedItem));
        }
        setSelectedViewTab(String(activeTab));
        setViewDocs('');
      });
      dispatch(setGlobalSelectedScopeItem(null));
    }
  };

  const getDtSyntaxQuery = async (builderData?: any) => {
    setSaveSearchLoader(true);
    try {
      const converted = convertBetweenInRuleGroup(builderData || builder);
      const jsonLogic = formatQuery(
        transformQuery(converted, { operatorMap: { ...jsonLogicOperatorMap } }),
        'jsonlogic'
      );
      rawQuery.current = parseQuery(jsonLogic);
      dispatch(setDTSyntaxQuery(rawQuery.current));
      rawQuery.current && setOpenSaveSearch(true);
      setSaveSearchLoader(false);
    } catch (_) {
      setSaveSearchLoader(false);
      showToast(
        t('ecaDocList.saveSearch.dtSyntaxFailed'),
        'error',
        undefined,
        'center'
      );
    }
  };

  const onSavedSearchClick = useCallback(
    (builderData: any, fieldTempId: string) => {
      if (hasDisabledRGFs) {
        dispatch(setShowRGFWarningPopup(true));
        dispatch(setShouldAppendUpdateRGFMsg(true));
        dispatch(
          setDisabledRGFLabelArray(
            getDisabledRelationshipGFieldTextFromSavedSearch()
          )
        );
      } else if (!isEmpty(getDisabledRelationshipGFieldText())) {
        dispatch(setDisabledRGFLabelArray(getDisabledRelationshipGFieldText()));
        dispatch(setShouldAppendUpdateRGFMsg(true));
        dispatch(setShowRGFWarningPopup(true));
      } else if (builderData.rules?.length && fieldTempId) {
        getDtSyntaxQuery(builderData);
      } else {
        setOpenSaveSearch(true);
      }
    },
    [
      dispatch,
      getDisabledRelationshipGFieldText,
      getDisabledRelationshipGFieldTextFromSavedSearch,
      getDtSyntaxQuery,
      hasDisabledRGFs,
      queryData,
    ]
  );

  const hiddenClearQueryBuilderAlert = useCallback(() => {
    setIsShowQueryBuilderConfirmationAlert(false);
  }, []);

  const handleOnContinueClearQueryBuilder = useCallback(() => {
    setShowECADrawer(true);
    setActiveTab(0);
    dispatch(setFilterList(defaultFilterModel));
    dispatch(resetQuery());
    handleViewDocs(LOAD_DOC_TYPE.ALL_DOC, allDocumentsItem);
    setActiveLoadFile(allDocumentsItem);
    setQueryText('');
    hiddenClearQueryBuilderAlert();
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.global.continue'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.ecaDocList.clearSearchQueryAndFiltersCompleted'),
      },
      subPage: {
        subpage_name: t(
          'gaTracking.ecaDocList.clearSearchQueryAndFiltersSubPage'
        ),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });
  }, [
    allDocumentsItem,
    dispatch,
    handleViewDocs,
    hiddenClearQueryBuilderAlert,
  ]);

  const handleOnCancelClearQueryBuilderAlert = useCallback(() => {
    trackGAEvent({
      eventName: GA_EVENT_NAMES.CLICK,
      click: {
        name: t('gaTracking.global.cancel'),
        type: GA_CLICK_TYPES.BUTTON,
        region: GA_REGIONS.MODAL,
        action: t('gaTracking.ecaDocList.clearSearchQueryAndFiltersCancel'),
      },
      subPage: {
        subpage_name: t(
          'gaTracking.ecaDocList.clearSearchQueryAndFiltersSubPage'
        ),
        subpage_type: GA_SUBPAGE_TYPE.MODAL,
      },
    });

    hiddenClearQueryBuilderAlert();
  }, [hiddenClearQueryBuilderAlert]);

  const handleContinueWarningQueryModel = () => {
    setQueryWarningPopup({ visible: false });
    checkQueryValidation(inputQuery);
  };

  const handleOnOKQueryRGFWarningAlert = useCallback(() => {
    dispatch(setShowRGFWarningPopup(false));
    dispatch(setShouldAppendUpdateRGFMsg(false));
    dispatch(setDisabledRGFLabelArray([]));
  }, [dispatch]);

  const handleOnCancelWarningQueryModel = () => {
    setQueryWarningPopup({ visible: false });
    setInputQuery('');
  };

  const getTemplateValidationModalContent = (
    contentHeading: string,
    contentBody: string | React.ReactElement
  ) => {
    return (
      <Box>
        <Typography className="content-heading">{contentHeading}</Typography>
        <Typography className="content-text">{contentBody}</Typography>
      </Box>
    );
  };

  return (
    <>
      <BulkTaggingStatusBanner />
      <AurPopup
        className="inactivity-popup-modal error-modal custom-tag-dialog-model template-validation-error"
        open={showValidationErrorModal}
        showPopupTitle={true}
        showPopupHeading={true}
        showCancelOption={false}
        showCloseIcon={false}
        popupHeading={t('savedSearchesTemplate.validationModal.heading')}
        contentType="element"
        popupContent={templateValidationModalContent}
        labelActionOk={t('savedSearchesTemplate.validationModal.onOk')}
        aria-label={t('savedSearchesTemplate.validationModal.onOk')}
        onOk={() => setShowValidationErrorModal(false)}
        onCancel={() => false}
      />
      <Box
        className={
          showECADrawer
            ? `aur-index-search-page-show-eca-drawer ${isSavedSearchSuccess ? 'saved-search-success' : ''}`
            : ''
        }
      >
        <div id="left-focusable-element">
          <Box
            className={`index-search-container ${queryBuilderMode ? 'query-builder-height' : 'adhoc-search-height'}`}
            ref={containerRef}
          >
            <Box className={`aur-index-search-page`}>
              <BackgroundImage className="bg-image" aria-hidden="true" />
              <Box className="header-content">
                <Box className="eca-button-container" id="coreeci-nav">
                  <Box className="drawer-and-button-container">
                    {!showECADrawer && (
                      <AurIconButton
                        size="big"
                        icon={<ExpandPanel aria-hidden="true" />}
                        onClick={() => {
                          setShowECADrawer(!showECADrawer);
                        }}
                        className="drawer-button"
                        ariaLabel={t('common.pagination.navigationHint')}
                        dataTestId="expand-panel"
                      />
                    )}
                    <Link
                      to={`/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`}
                      data-testid={'eca-home-link'}
                      className="back-link"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                      onClick={onECAClick}
                    >
                      <AurIcon icon={IconNames.ArrowBack} />

                      <Typography className="typo-text buttonMedium_size button-text">
                        {t('indexSearchPage.back')}
                      </Typography>
                    </Link>
                  </Box>
                  {hasAuditReportsPerm && (
                    <Link
                      to="/eci-home-page/search-report"
                      data-testid={'eca-home-search-report'}
                      className="back-link"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                      onClick={onECAViewSearchReportClick}
                    >
                      <Typography className="typo-text buttonMedium_size button-text">
                        {t('indexSearchPage.viewSearchAuditReport')}
                      </Typography>
                      <AurIcon icon={IconNames.ChevronRight} />
                    </Link>
                  )}
                </Box>
                <Grid container className={'second-line'}>
                  <Grid item className="select-index-container" xs={4}>
                    <Typography
                      component="span"
                      className="typo-text buttonMedium_size select-index-text"
                      tabIndex={0}
                    >
                      {t('indexSearchPage.searchIndex')}
                    </Typography>
                    {index?.name ? (
                      <>
                        <Button
                          aria-controls={open ? 'dropdown-menu' : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? 'true' : undefined}
                          data-testid="select-index-container"
                          onClick={onClickMenuButton}
                          endIcon={
                            <AurIcon
                              icon={
                                !open ? IconNames.CaretDown : IconNames.CaretUp
                              }
                              color={IconColors.Custom}
                            />
                          }
                          className={`typo-text buttonSmall_size button-exit  ${open ? 'open' : ''}`}
                          size="small"
                        >
                          <Typography className="typo-text buttonMedium_size clamp">
                            {index?.name}
                          </Typography>
                        </Button>
                        <AurMenu
                          anchorElement={anchorEl}
                          shouldShow={open}
                          onClose={handleClose}
                          menuItems={indexMenuList}
                          direction="left"
                          aria-labelledby="addUserButton"
                          cssClassName="aur-index-menu-dropdown"
                        />
                      </>
                    ) : null}
                  </Grid>
                  <Grid item xs={4}>
                    {hasAIInvestigatePerm && nlpSearchEnabled ? (
                      <AurEcaBanner
                        nlpBackLabel={t('common.search')}
                        onClick={() => {
                          trackGAEvent({
                            eventName: GA_EVENT_NAMES.CLICK,
                            click: {
                              name: t(
                                'gaTracking.indexSearch.exploreWithInvestigativeSearch'
                              ),
                              type: GA_CLICK_TYPES.BUTTON,
                              region: GA_REGIONS.BODY,
                              action: `${window.location.host}/nlp-search`,
                            },
                          });
                        }}
                      />
                    ) : null}
                  </Grid>
                  <Grid item className="link2" xs={4}>
                    {hasSearchTermReportPerm && (
                      <>
                        <Typography
                          component="span"
                          className="typo-text buttonMedium_size select-index-text"
                        >
                          {t('indexSearchPage.runA')}
                        </Typography>
                        <Link
                          to={`/eci-home-page/?tab=${EciHomePageTabs.STR}`}
                          data-testid={'report-link'}
                          onClick={onReportClick}
                        >
                          <AurButton
                            endIcon={<AurIcon icon={IconNames.ChevronRight} />}
                            type="text"
                            size="Medium"
                            classNames="question-link"
                            dataTestId="asking-question-btn"
                          >
                            <Typography
                              component="span"
                              className="typo-text buttonMedium_size select-index-text"
                            >
                              &nbsp;{t('indexSearchPage.searchTermReport')}
                            </Typography>
                          </AurButton>
                        </Link>
                      </>
                    )}
                  </Grid>
                </Grid>
                <div id="error-id" ref={errorBannerRef}>
                  <SearchResultErrorBanner />

                  {index?.status === 'InProgress' && (
                    <div className="error-toast">
                      <AurBanner
                        errorText={t('indexSearchPage.indexingInprogress')}
                        errorType="warning"
                        showIcon={true}
                      />
                    </div>
                  )}
                  {runSearchError.message && (
                    <div className="error-toast">
                      <AurBanner
                        errorText={runSearchError.message}
                        errorType="error"
                      />
                    </div>
                  )}
                </div>
                {queryBuilderMode ? (
                  <DndProvider backend={HTML5Backend}>
                    <QueryBuilderWrapper
                      onClickRunSearch={OnClickRunSearch}
                      setQueryBuilderMode={backFromQueryBuilder}
                      onPressAddRelationshipGroup={onClickAddRelationshipGroup}
                      selectedRelationshipGroupArray={getSelectedRelationshipGroupTextArray()}
                      onSaveSearchClick={() => {
                        if (!isDisabledRGFExist()) {
                          getDtSyntaxQuery();
                        }
                      }}
                      saveSearchLoader={saveSearchLoader}
                      ref={queryRef}
                      onHeightChange={handleHeightChange}
                    />
                  </DndProvider>
                ) : (
                  <>
                    <Grid container className="custodian-dropdowns" spacing={2}>
                      <Grid item xs={6}>
                        <AurDatePicker
                          shouldShowDateInputWithinPopover
                          type="query-date-picker"
                          advanceLink={false}
                          placeholder={t(
                            'common.aurDatePicker.selectDateRange'
                          )}
                          onApplyClick={(dates, operator) => {
                            setClearFamilyDate(false);
                            setRunSearchError({
                              ...runSearchError,
                              runSearchDisabled: false,
                            });
                            const startDate = `${dates[0]?.format('YYYY/MM/DD')}`;
                            const endDate =
                              operator == 'Between'
                                ? `${dates[1]?.format('YYYY/MM/DD')}`
                                : '';
                            const familyDate = buildDtSearchQuery(
                              operator,
                              startDate,
                              endDate
                            );
                            isEmpty(queryText)
                              ? setQueryText(`(${familyDate})`)
                              : generateSyntax(familyDate);

                            trackGAEvent({
                              eventName: GA_EVENT_NAMES.CLICK,
                              click: {
                                name: t('gaTracking.global.apply'),
                                type: GA_CLICK_TYPES.BUTTON,
                                region: GA_REGIONS.BODY,
                                action: t(
                                  'gaTracking.indexSearch.selectedDateRange'
                                ),
                              },
                            });
                          }}
                          clearDates={clearFamilyDate}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <CustodiansDropdown
                          onOpenDropdown={() => {
                            trackGAEvent({
                              eventName: GA_EVENT_NAMES.CLICK,
                              click: {
                                name: t(
                                  'gaTracking.indexSearch.allProcessedCustodians'
                                ),
                                type: GA_CLICK_TYPES.DROPDOWN,
                                region: GA_REGIONS.BODY,
                                action: t(
                                  'gaTracking.indexSearch.custodianAndFilterDropdown'
                                ),
                              },
                            });
                          }}
                          selectedCustodians={selectedCustodians}
                          queryConditionType={queryConditionType}
                          {...resetCustodian}
                          onApplyClick={(
                            selectedCustodians,
                            queryConditionType
                          ) => {
                            const custodianQuery = generateCustodianQuery(
                              selectedCustodians,
                              queryConditionType
                            );
                            isEmpty(queryText)
                              ? setQueryText(`(${custodianQuery})`)
                              : generateSyntax(custodianQuery);
                            setRunSearchError({
                              ...runSearchError,
                              runSearchDisabled: false,
                            });
                            resetCustodian.setSelectedCustodians([]);
                            trackGAEvent({
                              eventName: GA_EVENT_NAMES.CLICK,
                              click: {
                                name: t(
                                  'gaTracking.indexSearch.applyCustodian'
                                ),
                                type: GA_CLICK_TYPES.BUTTON,
                                region: GA_REGIONS.DROPDOWN,
                                action: t(
                                  'gaTracking.indexSearch.custodianAndFilterApplied'
                                ),
                                details: t(
                                  'gaTracking.indexSearch.filterSelected',
                                  {
                                    name: queryConditionType,
                                  }
                                ),
                              },
                            });
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Box className={'adhoc-search-container'}>
                      <AurAdhocSearchTextArea
                        ref={searchInputRef}
                        inputRef={queryTextFieldRef}
                        hasSearchesPerm={hasSearchesPerm}
                        value={queryText}
                        selectedRelationshipGroupArray={getSelectedRelationshipGroupTextArray()}
                        onChange={onChangeQueryText}
                        onPressBuildQuery={onClickBuildWithWizard}
                        onPressAddRelationshipGroup={
                          onClickAddRelationshipGroup
                        }
                        savedSearchScopeTextArea={savedSearchScopeTextArea}
                        onClickRunSearch={OnClickRunSearch}
                        onClickClearAllButton={onClickClearAllButton}
                        runDisabled={isRunSearchButtonDisabled()}
                        clearAllDisabled={isAllFieldsCleared()}
                        onHeightChange={handleHeightChange}
                      />
                    </Box>
                  </>
                )}
              </Box>
              <ClearConfirmAlertPopup
                data-testid={'clearConfirmAlertPopup'}
                queryText={queryText}
                popupType={confirmPopupType}
                onOk={() => {
                  if (
                    confirmPopupType === ClearConfirmPopupType.buildWithWizard
                  ) {
                    onClickOkFromClearConfirmPopup(
                      true,
                      ClearConfirmPopupType.confirmClearSearch
                    );
                  }
                  onClickOkFromClearConfirmPopup(true);
                }}
                onCancel={onCancelClearAllFilter}
                showDialog={isConfirmDialogVisible}
              />
              <LeaveSearchConfirmationDialog
                searchQuery={queryText}
                setQueryBuilderMode={setQueryBuilderMode}
                onLeavePageConfirm={() => {
                  onClickOkFromClearConfirmPopup();
                  if (queryBuilderMode) {
                    setQueryBuilderMode(false);
                    trackGAEvent({
                      eventName: GA_EVENT_NAMES.CLICK,
                      click: {
                        name: t('gaTracking.queryBuilder.leaveWithoutSaving'),
                        type: GA_CLICK_TYPES.BUTTON,
                        region: GA_REGIONS.MODAL,
                        action: t('gaTracking.global.confirmUnsavedModal'),
                      },
                      subPage: {
                        subpage_name: t(
                          'gaTracking.global.unsavedChangesSubpageName'
                        ),
                        subpage_type: GA_SUBPAGE_TYPE.MODAL,
                      },
                    });
                  } else {
                    trackGAEvent({
                      eventName: GA_EVENT_NAMES.CLICK,
                      click: {
                        name: t('gaTracking.queryBuilder.leaveWithoutSaving'),
                        type: GA_CLICK_TYPES.BUTTON,
                        region: GA_REGIONS.MODAL,
                        action: t('gaTracking.global.confirmUnsavedModal'),
                      },
                      subPage: {
                        subpage_name: t(
                          'gaTracking.global.unsavedChangesSubpageName'
                        ),
                        subpage_type: GA_SUBPAGE_TYPE.MODAL,
                      },
                    });
                  }
                }}
              />
              <RelationshipGroupPopup
                ref={relationshipGroupPopupRef}
                relationalGroupArray={relationalGroupArray}
                selectedIdArray={selectedRelationGroupIdArray}
                onCancel={() => {
                  trackGAEvent({
                    eventName: GA_EVENT_NAMES.CLICK,
                    click: {
                      name: t('gaTracking.global.cancel'),
                      type: GA_CLICK_TYPES.BUTTON,
                      region: GA_REGIONS.MODAL,
                      action: t(
                        'gaTracking.indexSearch.relationalGroupAdditionCancel'
                      ),
                    },
                    subPage: {
                      subpage_name: t(
                        'gaTracking.indexSearch.relationalGroupFieldSelected'
                      ),
                      subpage_type: GA_SUBPAGE_TYPE.MODAL,
                    },
                  });
                }}
                onSelectIds={(ids: number[]) => {
                  onSelectRelationshipGroupIds(ids);
                  if (queryBuilderMode) {
                    trackGAEvent({
                      eventName: GA_EVENT_NAMES.CLICK,
                      click: {
                        name: t('gaTracking.queryBuilder.addRelationalGroup'),
                        type: GA_CLICK_TYPES.BUTTON,
                        region: GA_REGIONS.BODY,
                        action: t('gaTracking.queryBuilder.addAction'),
                      },
                    });
                  } else {
                    trackGAEvent({
                      eventName: GA_EVENT_NAMES.CLICK,
                      click: {
                        name: t('gaTracking.global.save'),
                        type: GA_CLICK_TYPES.BUTTON,
                        region: GA_REGIONS.MODAL,
                        action: t(
                          'gaTracking.indexSearch.relationalGroupAdditionComplete'
                        ),
                      },
                      subPage: {
                        subpage_name: t(
                          'gaTracking.indexSearch.relationalGroupFieldSelected'
                        ),
                        subpage_type: GA_SUBPAGE_TYPE.MODAL,
                      },
                    });
                  }
                }}
              />
            </Box>
            <Box className="doc-list-container">
              <ResizableDocList
                searchInputRef={queryBuilderMode ? queryRef : searchInputRef}
                updateHeightsRef={updateHeightsRef}
                containerRef={containerRef}
                errorBannerRef={errorBannerRef}
              >
                <EcaDocListGrid
                  ref={gridRef}
                  rowData={searchSseData?.SearchId ? undefined : []}
                  searchID={searchSseData?.SearchId}
                  docSetId={searchSseData?.DocSetId}
                  searchTime={searchTime}
                  openSaveSearch={openSaveSearch}
                  setOpenSaveSearch={setOpenSaveSearch}
                  viewDocType={viewDocs}
                  selectedIndex={index?.name}
                  stdIndexFieldTemplateId={stdIndexFieldTemplateId}
                  handleGlobalSelectedItem={handleGlobalSelectedItem}
                  openDrawer={(data) => {
                    setIsShowQueryBuilderConfirmationAlert(data);
                  }}
                  hasSelectedFamilyGroupIdentifier={
                    hasSelectedFamilyGroupIdentifier
                  }
                  apiControllers={abortControllers.current}
                  onSaveSearchClick={onSavedSearchClick}
                  saveSearchLoader={saveSearchLoader}
                  runSearchError={runSearchError}
                  setRunSearchError={setRunSearchError}
                  onCancelClick={onCancelClick}
                />
              </ResizableDocList>
            </Box>
          </Box>
        </div>
        {showECADrawer && (
          <div id="left-focusable-element">
            <ECADrawerWithTabs
              showDrawer={showECADrawer}
              handleDrawer={setShowECADrawer}
              handleViewDocs={handleViewDocs}
              selectedIndex={index?.name}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              activeLoadFile={activeLoadFile}
              setActiveLoadFile={setActiveLoadFile}
              selectedTag={selectedTag}
              selectedNode={selectedNode}
              expandedIds={expandedIds}
              loadWithFlyout={openWithFlyout}
              handleUseAsScope={handleUseAsScope}
              handleAddToTemplate={handleAddToTemplate}
              onPickTreeItem={(treeItem) => setSelectedTreeItem(treeItem)}
            />
          </div>
        )}
        {searchLoader && (
          <AurEcaSearchLoader
            isOpen={searchLoader}
            onClose={handleLoaderClose}
            keepMounted
          />
        )}
        {validationLoader && (
          <AurEcaValidationLoader
            isOpen={validationLoader}
            onClose={handleLoaderClose}
            keepMounted
          />
        )}
        {
          <AurPopup
            className="aur-unsaved-changes-popup custom-confirme-popup"
            open={deduplicationModal}
            onOk={() => {
              dispatch(resetQuery());
              if (viewDocs === LOAD_DOC_TYPE.LOAD_SCOPE) {
                dispatch(setGlobalSelectedScopeItem(shadowGlobalSelectedItem));
                dispatch(setCloseFlyout(true));
                setDeduplicationModal(false);
                setSearchTime('');
                if (
                  selectedViewTab &&
                  globalSelectedItem &&
                  activeTab != Number(selectedViewTab)
                ) {
                  dispatch(setShowSetScopeLoader(true));
                  setTimeout(() => {
                    dispatch(setShowSetScopeLoader(false));
                    setActiveTab(Number(selectedViewTab));
                  }, 1000);
                }
                setSavedSearchScopeTextArea('');
                trackGAEvent({
                  eventName: GA_EVENT_NAMES.CLICK,
                  click: {
                    name: t('gaTracking.indexSearch.yesContinue'),
                    type: GA_CLICK_TYPES.BUTTON,
                    region: GA_REGIONS.MODAL,
                    action: t('gaTracking.indexSearch.confirmUseAsScope'),
                  },
                  subPage: {
                    subpage_name: t(
                      'gaTracking.indexSearch.continueToUseAsScope'
                    ),
                    subpage_type: GA_SUBPAGE_TYPE.MODAL,
                  },
                });
              } else {
                dispatch(setGlobalSavedSearchDetails(null));
                setSavedSearchScopeTextArea('');
                dispatch(setGlobalSelectedItem(null));
                dispatch(setSearchLoader(true));
                dispatch(setViewDocName(LOAD_DOC_TYPE.LOAD_DOC));
                dispatch(setCloseFlyout(true));
                resetSearchSse();
                generateSearchId();
                setDeduplicationModal(false);
              }
            }}
            onCancel={() => {
              setQueryBuilderMode(isQueryBuilderRef.current);
              setDeduplicationModal(false);
              setViewDocs('');
              trackGAEvent({
                eventName: GA_EVENT_NAMES.CLICK,
                click: {
                  name: t('gaTracking.global.cancel'),
                  type: GA_CLICK_TYPES.BUTTON,
                  region: GA_REGIONS.MODAL,
                  action: t('gaTracking.indexSearch.canceledUseAsScope'),
                },
                subPage: {
                  subpage_name: t(
                    'gaTracking.indexSearch.continueToUseAsScope'
                  ),
                  subpage_type: GA_SUBPAGE_TYPE.MODAL,
                },
              });
            }}
            onClose={(e) => {
              e.preventDefault();
              setDeduplicationModal(false);
            }}
            popupHeading={t('indexSearchPage.deduplicationModal.heading', {
              loadFile: shadowGlobalSelectedItem?.name,
            })}
            showPopupHeading={true}
            showPopupTitle={true} // Show blank title To aligne close icon
            showCloseIcon={true}
            popupContent={
              <Typography className="typo-text body2_size custom-color-text-mist-400">
                {t('indexSearchPage.deduplicationModal.content')}
              </Typography>
            }
            labelActionCancel={t('buttons.cancel')}
            labelActionOk={t('buttons.yesContinue')}
            contentType="element"
          />
        }
      </Box>
      {isShowQueryBuilderConfirmationAlert && (
        <QueryBuilderClearConfirmationAlert
          showDialog={isShowQueryBuilderConfirmationAlert}
          onCancel={handleOnCancelClearQueryBuilderAlert}
          onOk={handleOnContinueClearQueryBuilder}
        />
      )}
      {selectedSearchId && (
        <EcaAddToSaveSearchTemplate
          setShowDrawer={() => {
            setOpenSavedSearchTemplateDrawer(false);
          }}
          handleCloseDrawer={() => {
            setSelectedSearchId('');
            setSelectedSearchName('');
          }}
          onSaveToTemplate={(value) => {
            setIsSavedSearchSuccess(value);
          }}
          showDrawer={openSavedSearchTemplateDrawer}
          searchClientId={clientId}
          searchId={selectedSearchId}
          searchName={selectedSearchName}
        />
      )}
      {queryWarningPopup.visible && (
        <QueryWarningPopupAlert
          showDialog={queryWarningPopup.visible}
          onCancel={handleOnCancelWarningQueryModel}
          onOk={handleContinueWarningQueryModel}
          queryErrorTypes={queryWarningPopup.errorTypes ?? []}
        />
      )}
      {showRGFWarningPopup && (
        <RGFWarningPopupAlert
          disabledRGFLabelArray={disabledRGFLabelArray}
          shouldAppendUpdateRGFMsg={shouldAppendUpdateRGFMsg}
          showDialog={showRGFWarningPopup}
          onOk={handleOnOKQueryRGFWarningAlert}
          onCancel={handleOnOKQueryRGFWarningAlert}
        />
      )}
    </>
  );
};

export default IndexSearchPage;
